import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  isActive?: boolean;
}

export const IconManagementReport: React.FC<Props> = ({ isActive }) => {
  const colors = useTheme().colors;
  const stroke = isActive ? colors.gp1 : colors.cflowerBlue;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M8.2955 4.41016L4.40661 4.41016M6.9992 7.00275L4.40661 7.00275M9.5918 9.59534L4.40661 9.59534"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1855 11.5383L12.1855 2.46427C12.1855 1.74834 11.6052 1.16797 10.8893 1.16797L3.11147 1.16797C2.39555 1.16797 1.81518 1.74834 1.81518 2.46427L1.81518 11.5383C1.81518 12.2543 2.39555 12.8346 3.11147 12.8346L10.8893 12.8346C11.6052 12.8346 12.1855 12.2543 12.1855 11.5383Z"
        stroke={stroke}
        strokeWidth="1.2"
      />
    </svg>
  );
};
